import createSvgIcon from '../Utils/CreateSvgIcon';

export const Branches = createSvgIcon(
  <path
    fillRule="evenodd"
    d="
      M14.5 5A2.5 2.5 0 1 1 9.5 5A2.5 2.5 0 1 1 14.5 5Z
      M11 7.5H13V10.25H11Z
      M4.25 10.25H19.75V11.75H4.25Z
      M4.25 11.75H6.25V16H4.25Z
      M11 11.75H13V16H11Z
      M17.75 11.75H19.75V16H17.75Z
      M7 18A2 2 0 1 1 3 18A2 2 0 1 1 7 18Z
      M14 18A2 2 0 1 1 10 18A2 2 0 1 1 14 18Z
      M21 18A2 2 0 1 1 17 18A2 2 0 1 1 21 18Z
    "
  />,
  'Branches',
);
